export const AlertReducer = (state, action) => {
    switch (action.type) {
        case "SHOW_NOTIFICATION":
            return {...state, ...action.data};
        case "REMOVE_NOTIFICATION":
            const notification = {alert: {}}
            return {...state, ...notification};
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/alert/reducers/AlertReducer.js